var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-responsive', {
    staticClass: "mx-auto overflow-visible",
    attrs: {
      "max-width": "1024px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "headline text-start mt-8"
  }, [_vm.notification._id ? _c('span', [_vm._v("공지사항 수정")]) : _c('span', [_vm._v("공지사항 등록")])]), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("제목")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.notification.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.notification, "subject", $$v);
      },
      expression: "notification.subject"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("카테고리")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.categories,
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.notification.category,
      callback: function callback($$v) {
        _vm.$set(_vm.notification, "category", $$v);
      },
      expression: "notification.category"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("상단고정")]), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-switch', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.notification.isNotice,
      callback: function callback($$v) {
        _vm.$set(_vm.notification, "isNotice", $$v);
      },
      expression: "notification.isNotice"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-layout', [_c('span', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("파일 업로드")])]), _c('v-card', [_c('v-card-text', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.$refs.uploads.$el.getElementsByTagName('input')[0].click();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("추가")], 1), _c('v-file-input', {
    ref: "uploads",
    staticClass: "d-none",
    attrs: {
      "multiple": "",
      "accept": ".pdf, .xls, .xlsx"
    },
    on: {
      "change": function change($event) {
        _vm.upload(Array.isArray(_vm.uploads) ? _vm.uploads : [_vm.uploads]).then(function (res) {
          return _vm.$set(_vm.notification, 'uploads', [].concat(_vm.notification.uploads || [], res));
        });
      }
    },
    model: {
      value: _vm.uploads,
      callback: function callback($$v) {
        _vm.uploads = $$v;
      },
      expression: "uploads"
    }
  })], 1), _vm._l(_vm.notification.uploads, function (item, index) {
    return [_c('v-divider', {
      key: 'divider' + index
    }), _c('v-row', {
      key: index,
      staticClass: "px-4",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', [_c('v-btn', {
      attrs: {
        "color": "blue",
        "outlined": ""
      },
      on: {
        "click": function click($event) {
          return _vm.download(item.src, item.name);
        }
      }
    }, [_vm._v(_vm._s(item.name)), _c('v-icon', {
      attrs: {
        "size": "16",
        "right": ""
      }
    }, [_vm._v("mdi-download")])], 1)], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function click($event) {
          return _vm.notification.uploads.splice(index, 1);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "18"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1)];
  })], 2)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-layout', [_c('span', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("상세내용")])]), _c('v-card', [_c('v-card-text', [_c('naver-smarteditor', {
    model: {
      value: _vm.notification.content,
      callback: function callback($$v) {
        _vm.$set(_vm.notification, "content", $$v);
      },
      expression: "notification.content"
    }
  })], 1)], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue darken-1"
    },
    on: {
      "click": function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v("저장")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }